import gql from 'graphql-tag';

export const createHighlight = gql`
	mutation createHighlight($highlight: HighlightInput!) {
		createHighlight(highlight: $highlight) {
			id
		}
	}
`;
